import styled from "styled-components";
import { Button } from "../../Button";
import TextInput from "../TextInput";

export const NumberInput = styled(TextInput)`
    & {
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            /* display: none; <- Crashes Chrome on hover */
            -webkit-appearance: none;
            margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
        }

        input[type="number"] {
            -moz-appearance: textfield; /* Firefox */
        }
    }
`;

export const RoundButton = styled(Button)`
    border-radius: 50%;
    padding: 0;

    width: 20px;
    height: 20px;

    background-color: ${({ theme }) => theme.v2.colors["primary-900"]};

    &:before {
        border-radius: 50%;
    }

    div {
        margin-bottom: 0.5px;
    }

    svg {
        width: 11px;
        height: 11px;
    }
`;
